import { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { apiRequest } from '../authConfig';
import { getTokenSilently } from '../authService';
import { useAppContext } from '../context/AppContext';
import { AppActionTypes } from '../context/AppContext';
import { apiService } from '../services/apiService';

/**
 * Custom hook for managing authentication state and token handling
 */
export function useAuthentication() {
  const { state, dispatch } = useAppContext();
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();

  // Get ID token when user is authenticated
  useEffect(() => {
    const getIdToken = async () => {
      console.log('Authentication status check - isAuthenticated:', isAuthenticated, 'accounts length:', accounts.length);
      
      if (isAuthenticated && accounts.length > 0) {
        try {
          console.log('Account information:', accounts[0]);
          console.log('Attempting to get ID token...');
          
          const token = await getTokenSilently(apiRequest);
          
          if (token) {
            console.log('ID Token successfully obtained. First 10 chars:', token.substring(0, 10) + '...');
            console.log('ID Token length:', token.length);
            
            // Set the token in both component state and API service
            dispatch({ type: AppActionTypes.SET_AUTH_TOKEN, payload: token });
            apiService.setAuthToken(token);
            
            console.log('Auth token state updated');
          } else {
            console.error('ID Token returned was empty or undefined!');
            dispatch({ type: AppActionTypes.SET_AUTH_TOKEN, payload: null });
            apiService.setAuthToken(null);
          }
        } catch (error) {
          console.error('Error getting ID token:', error);
          dispatch({ type: AppActionTypes.SET_AUTH_TOKEN, payload: null });
          apiService.setAuthToken(null);
        }
      } else {
        console.log('User not authenticated or no accounts, setting token to null');
        dispatch({ type: AppActionTypes.SET_AUTH_TOKEN, payload: null });
        apiService.setAuthToken(null);
      }
    };

    getIdToken();
  }, [isAuthenticated, accounts, dispatch]);

  // Monitor changes to authToken
  useEffect(() => {
    console.log('authToken changed:', state.authToken ? `Token available (starts with ${state.authToken.substring(0, 10)}...)` : 'No token set');
  }, [state.authToken]);

  return {
    isAuthenticated,
    authToken: state.authToken,
    accounts,
  };
}
